import { render, staticRenderFns } from "./PanelBase.vue?vue&type=template&id=04a1a895&scoped=true&lang=pug"
import script from "./PanelBase.vue?vue&type=script&lang=js"
export * from "./PanelBase.vue?vue&type=script&lang=js"
import style0 from "./PanelBase.vue?vue&type=style&index=0&id=04a1a895&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a1a895",
  null
  
)

export default component.exports